import React, {
  createContext,
  useContext,
  useReducer,
  useRef,
} from "react";
import { drawerReducer } from "reducers/drawerReducer";

// Create context
export const DrawerContext = createContext();

// Initial state
const initialState = {
  showDrawer: false,
};

// Provider
const DrawerProvider = ({ children }) => {
  const [drawerState, drawerDispatch] = useReducer(drawerReducer, initialState);
  const drawerRef = useRef(null);

  return (
    <DrawerContext.Provider
      value={{ drawerState, drawerDispatch, drawerRef }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

// Hook
export const useDrawerContext = () => useContext(DrawerContext);

export default DrawerProvider;
